<div class="card text-gris">
    <div class="card-header">
        <div class="row align-items-center">
            <div class="col-9" data-testid="titulo">
                {{editando ? 'Editar cliente' : 'Agregar cliente' }} {{editando && esMobile ? '#' + cliente.id : ''}}
            </div>
            <div class="col-3 text-end seleccionable" (click)="cerrar()" data-testid="boton-cerrar">
                <app-svg-icon icon="x" [size]="30"></app-svg-icon>
            </div>
        </div>
    </div>
    <div class="card-body">
        <form>
            <div class="mb-3">
                <label class="form-label" for="nombre">Nombre</label>
                <input type="text" class="form-control form-control-sm" name="nombre" id="nombre"
                    [(ngModel)]="cliente.nombre" placeholder="Nombre">
            </div>
            <div class="mb-3">
                <label class="form-label" for="password">Contraseña</label>
                <input type="password" class="form-control form-control-sm" name="password" id="password"
                    [(ngModel)]="cliente.password" placeholder="Contraseña">
            </div>
            <div class="mb-3">
                <label class="form-label" for="email">Correo electrónico</label>
                <input type="email" class="form-control form-control-sm" name="email" id="email"
                    [(ngModel)]="cliente.email" placeholder="Correo electrónico">
            </div>
        </form>
        <ng-container *ngIf="editando">
            <div class="row pt-3">
                <div class="col-12">
                    <span data-testid="subscripcion">
                        Subscripcion: {{cliente.subscriptionNombre ?? 'Sin subscripcion'}}
                    </span>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-12">
                    <span data-testid="fecha-alta">
                        Fecha Alta: {{cliente.creadoEl | date: 'dd/MM/yyyy'}}
                    </span>
                </div>
            </div>
            <div class="row pt-2">
                <div class="col-12">
                    <span data-testid="ultima-actividad">
                        Ultima Actividad: {{cliente.ultimaActividad | date: 'dd/MM/yyyy'}}
                    </span>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="card-footer">
        <div class="row solo-botones">
            <div class="col flex-grow-0 my-auto seleccionable">
                <a class="text-danger" [command]="borrarCmd" *ngIf="editando" data-testid="boton-borrar">Eliminar</a>
            </div>
            <div class="col text-end">
                <button class="btn btn-secondary" (click)="cerrar()">Cancelar</button>
                <button *ngIf="!editando" class="btn btn-success" [command]="agregarCmd" data-testid="boton-agregar">
                    Agregar
                </button>
                <button *ngIf="editando" class="btn btn-success" [command]="guardarCmd" data-testid="boton-guardar">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>
